import React, { useState, useEffect, useCallback } from 'react';
import { useHistory } from "react-router-dom";
import { DataTable } from '../../../components/DataTable/DataTable';
import { useDataTable } from '../../../components/DataTable/useDataTable';
import Dialog from '../../../components/dialog/Dialog';
import ACCESS from '../../../ACCESS.js';
import { FormaPagoService } from '../../../services/FormaPagoService';

const FormasPagos = () => {
    const history = useHistory();
    const tableState = useDataTable({ initialLimit: 15 });
    
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    // Dialog state for deletion
    const [dialog, setDialog] = useState({ show: false, title: '', options: ['Sí', 'No'], row: null });

    const fetchData = useCallback(async () => {
        setLoading(true);
        const rows = await FormaPagoService.obtenerLista(
            tableState.page,
            tableState.limit,
            tableState.filters,
            tableState.orderBy,
            tableState.order
        );
        setData(rows);
        setLoading(false);
    }, [tableState.page, tableState.limit, tableState.filters, tableState.orderBy, tableState.order]);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    const hasMore = data.length === tableState.limit; 

    const columns = [
        {
                id: "forma_pago",
                label: "Clave"
        },
        {
                id: "forma_nombre",
                label: "Descripción"
        }
];

    const handleDeleteClick = (row) => {
        setDialog({
            show: true,
            title: `¿Borrar el registro ${row.forma_nombre || ''}?`,
            options: ['Sí', 'No'],
            row: row,
        });
    };

    const handleDialogClose = async (op) => {
        const rowToDelete = dialog.row;
        setDialog({ show: false, title: '', options: [], row: null });
        
        if (op === 1 && rowToDelete) {
            setLoading(true);
            const success = await FormaPagoService.eliminar(rowToDelete);
            if (success) {
                fetchData();
            } else {
                setLoading(false);
            }
        }
    };
    const actions = [
        {
            id: 'edit',
            icon: 'edit',
            access: ACCESS.CATALOGO_FORMAS_DE_PAGO.EDITAR_CATALOGO,
            onClick: (actionId, row) => history.push(`/Catalogo/FormaPago/${row.id}`)
        },
        {
            id: 'delete',
            icon: 'delete',
            access: ACCESS.CATALOGO_FORMAS_DE_PAGO.ELIMINAR_CATALOGO,
            onClick: (actionId, row) => handleDeleteClick(row)
        },
    ];

    return (
        <div className="w-full">
            <DataTable
                columns={columns}
                data={data}
                loading={loading}
                actions={actions}
                hasMore={hasMore}
                page={tableState.page}
                limit={tableState.limit}
                onPageChange={tableState.handlePageChange}
                onLimitChange={tableState.handleLimitChange}
                orderBy={tableState.orderBy}
                order={tableState.order}
                onSort={tableState.handleSort}
                filters={tableState.filters}
                onFilterChange={tableState.handleFilterChange}
                onRowClick={(row) => history.push(`/Catalogo/FormaPago/${row.id}`)}
            />
            <Dialog dialog={dialog} onClose={handleDialogClose} />
        </div>
    );
};

export default FormasPagos;
